import { IntegrityMonitorRulesAppBaseDataProvider } from './IntegrityMonitorRulesAppBaseDataProvider';
import { sanitizeObject } from '../../../../utils/sanitization.utils';
import { IntegrityMonitorDetailedAssignationData } from '../types';
import { IntegrityMonitorRuleGridItem } from '../../integrityMonitorRulesGrid/types';
import { Target } from '@nirvana/shared/company-helper/nestjs';

export class IntegrityMonitorRulesAppGzDataProvider extends IntegrityMonitorRulesAppBaseDataProvider {
  public async getRuleDetailedAssignationData(
    rulesIds: Array<string>
  ): Promise<IntegrityMonitorDetailedAssignationData> {
    const request = {
      rulesIds,
      companyId: this.dependencies.getActiveCompany().companyId,
    };

    try {
      const result = await this.dependencies.api.clients.IntegrityMonitorRules.getRulesDetailedAssignationDataByIds(
        request
      ).toPromise();

      return sanitizeObject(result);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async removeRecords(records): Promise<any> {
    try {
      const result = await this.dependencies.api.clients.IntegrityMonitorRules.removeRecords(records).toPromise();

      return sanitizeObject(result);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async deleteRuleSet(ruleSetId: string, companyId: string): Promise<Object | null> {
    try {
      const result = await this.dependencies.api.clients.IntegrityMonitorRuleSets.deleteRuleSet(
        ruleSetId,
        companyId
      ).toPromise();

      return sanitizeObject(result);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async readRuleOriginal(templateId: string): Promise<IntegrityMonitorRuleGridItem> {
    const request = {
      templateId,
      companyId: this.dependencies.getActiveCompany().companyId,
    };

    try {
      const result = await this.dependencies.api.clients.IntegrityMonitorRules.readRuleOriginal(request).toPromise();

      return sanitizeObject(result);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async updateNonConfigurableDefaultRule(rule: IntegrityMonitorRuleGridItem): Promise<any> {
    try {
      const result = await this.dependencies.api.clients.IntegrityMonitorRules.updateNonConfigurableDefaultRule(
        rule
      ).toPromise();

      return sanitizeObject(result);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  public async getAvailableCompanies(): Promise<Array<Target>> {
    try {
      const response = await this.dependencies.api.clients.Company.getAvailableCompanies({}).toPromise();

      return sanitizeObject(response.targets);
    } catch (e) {
      console.error(e);
      return [];
    }
  }
}
